import { ApiNumber } from 'types/models/ApiNumber';
import getListWithId from 'utils/getListWithId';
import { getNumber, getNumbers } from 'utils/getNumber';

import { Props as ProsAndConsSection } from './components/ProsAndCons';

const contactUsImageSection = {
  title: 'Skontaktuj się z nami i uzyskaj kompleksowe wsparcie w postaci:',
  buttonText: 'Skontaktuj się z nami',
  items: getListWithId([
    { text: 'dedykowanego opiekuna handlowego' },
    { text: 'indywidualnego doradztwa i wsparcia technicznego ' },
    { text: 'usług komplementarnych ' },
    { text: 'dopasowanej formy finansowania i płatności ' },
    { text: 'specjalnych cen ' },
    { text: 'pomocy w przygotowaniu niezbędnej dokumentacji' },
  ]),
};

const prosAndConsSection: ProsAndConsSection = {
  title: 'Spółka akcyjna, jeden ze światowych liderów sektora przemysłowego',
  descriptionFirstPart:
    'Skontaktowała się w sprawie wymiany sprzętu (PC, laptop, stacje robocze) na nowy – pierwsze szacunki obejmowały około 120 sztuk. ',
  descriptionSecondPart:
    'Podczas spotkań z klientem zidentyfikowaliśmy kluczowe problemy w zarządzaniu flotą sprzętu IT, zaproponowaliśmy rozwiązania i uzyskaliśmy ponad 100 000 PLN oszczędności.',
  consSection: {
    title: 'Problemy',
    items: getListWithId([
      {
        text: 'Wysokie koszty zarządzania i utrzymania floty IT spowodowane brakiem standaryzacji i unifikacji sprzętu',
      },
      { text: 'Nierówne poziomy wsparcia gwarancyjnego i serwisowego' },
      { text: 'Wysokie koszty zakupu pojedynczych jednostek' },
      { text: 'Wysokie koszty czasu zakupu i wdrażania pojedynczych jednostek do istniejącej infrastruktury' },
      { text: 'Problemy z magazynowaniem oraz pokryciem kosztu zakupu nowych jednostek w jednorazowej transzy' },
    ]),
  },
  firstPros: {
    title: 'Rozwiązania',
    items: getListWithId([
      {
        text: 'Kompleksowa obsługa pre-sales i wypracowanie systemowego podejścia do zarządzania i modernizacji floty IT',
      },
      {
        text: 'Opracowanie planu unifikacji serii i modeli, w zależności od wymagań parametrów technicznych w danej kategorii',
      },
      { text: 'Zunifikowanie poziomów wsparcia gwarancyjnego i serwisowego' },
      { text: 'Optymalizacja konfiguracji celem uzyskania najlepszego stosunku potrzeby – cena – dostępność' },
      {
        text: 'Przygotowanie całego sprzętu do użycia plug & play – wgranie obrazu systemu wraz z wymaganymi aplikacjami zewnętrznymi w fabryce producenta',
      },
      {
        text: 'Stworzenie magazynu dla klienta dla ponad 250 sztuk laptopów, PC, stacji roboczych i i realizowanie dostaw on-demand',
      },
      {
        text: 'Wsparcie w procesie pozyskiwania finansowania oraz umożliwienie płatności w transzach związanych z dostawami',
      },
      { text: 'Uzyskanie cen projektowych, wsparcia producenta i optymalizacja cenowa' },
    ]),
  },
  secondPros: {
    title: 'Rezultaty',
    items: getListWithId([
      {
        text: 'Zunifikowanie standardu w danych kategoriach sprzętowych, uaktualnianych zgodnie z aktualizacjami rynkowymi modeli',
      },
      { text: 'Łatwiejsze i tańsze zarządzanie flotą IT' },
      { text: 'Optymalizacja kosztu czasu zarządzania i administracji flotą IT' },
      { text: 'Ustandaryzowanie procesu wdrażania nowego sprzętu do istniejącej infrastruktury' },
      { text: 'Precyzyjne planowanie etapów modernizacji sprzętu' },
      { text: 'Precyzyjne planowanie budżetu inwestycyjnego po stronie klienta' },
      {
        text: 'Optymalizacja wsparcia gwarancyjnego i serwisowego producenta od daty dostawy danej jednostki do klienta',
      },
      { text: 'Znaczne oszczędności finansowe' },
    ]),
  },
  numbersSection: {
    title: 'Korzyści',
    numbers: [
      {
        value: '77,6',
        type: 'percent',
        description: 'Oszczędności czasu we wdrażaniu jednostek do infrastruktury',
      },
      {
        value: '167 498',
        type: 'number',
        description: 'złotych netto oszczędności w zakupie',
      },
      {
        value: '250',
        type: 'number',
        description: 'jednostek w dostawie "na życzenie"',
      },
      {
        value: 'bezcenne',
        type: 'number',
        description: 'zadowolenie z wdrożenia i dalsza stała współpraca',
      },
    ],
  },
};

export const getMock = (numbers: ApiNumber[] = []) => {
  const coconStartYear = getNumber(numbers, 'COCON_START_YEAR');

  return {
    heroSection: {
      title: 'Obsługa sektora publicznego',
      subtitle:
        'Specjalizujemy się w rozwiązaniach dla sektora publicznego, realizując zapytania ofertowe oraz uczestnicząc w postępowaniach przetargowych.',
    },
    firstSection: {
      title: `Od ${coconStartYear} roku dostarczamy sprzęt i rozwiązania IT dla sektora publicznego`,
      description: `Dostarczamy zarówno pojedyncze serwery jak kompletną infrastrukturę rozbudowanych serwerowni.\n\nJesteśmy oficjalnym partnerem największych producentów sprzętu IT, który podlega pełnej obsłudze serwisowej i gwarancyjnej producenta.\n\nNa każdym etapie procesu sprzedaży świadczymy pełne wsparcie techniczne: począwszy od przygotowania niezbędnej dokumentacji, poprzez wdrożenie, aż po obsługę powdrożeniową.`,
    },
    secondSection: {
      title: 'Instytucje publiczne obsługuje dedykowany zespół handlowy, wspierany przez doświadczonych inżynierów IT.',
      description:
        'Dzięki naszemu doświadczeniu instytucje publiczne zyskują pewność, że zakupiony sprzęt będzie zgodny z realnymi potrzebami, dostępny w wymaganym czasie oraz odpowiadający trendom rynkowym. Bez względu na to, czy takie zamówienie obejmuje 1 czy 100 jednostek sprzętowych, instytucjom publicznym zapewniamy:',
      itemsPerRow: 2,
      items: getListWithId([
        { text: 'analizę potrzeb' },
        { text: 'udział w postępowaniu' },
        { text: 'analizę techniczną' },
        { text: 'terminową dostawę' },
        { text: 'przygotowanie zakupu (SIWZ)' },
        { text: 'realizację formalności' },
        { text: 'wsparcie od producenta' },
        { text: 'usługę wdrożenia' },
      ]),
    },
    dialogBoxesSection: {
      firstSection: {
        title: 'Udzielamy wsparcia w analizie potrzeb przed planowaną inwestycją.',
        description:
          'Dostawy realizujemy na bazie umowy, zamówienia, postępowania, protokołu lub innych dokumentów ustalonych wspólnie z zamawiającym.',
        list: {
          title: 'Obsługujemy',
          items: getListWithId([
            { text: 'przetargi' },
            { text: 'zamówienia i zapytania ofertowe' },
            { text: 'inne formy stosowane przez zamawiającego' },
          ]),
        },
      },
      secondSection: {
        title: `Znamy przebieg procesu zakupowego w instytucjach publicznych. Każdego roku obsługujemy ponad ${getNumber(
          numbers,
          'PUBLIC_SECTOR_DELIVERIES_PER_YEAR'
        )} dostaw do instytucji publicznych.`,
        description:
          'Nasze doświadczenie w obsłudze procesu zakupowego w instytucjach publicznych sprawia, że realizacja zamówienia przebiega szybko i sprawnie.',
      },
    },
    prosAndConsSection,
    contactUsImageSection,
  };
};

export const getComplexDelivery = (numbers: ApiNumber[] = []) => {
  const [coconStartYear, devices] = getNumbers(numbers, ['COCON_START_YEAR', 'DEVICES_PER_YEAR']);

  return {
    heroSection: {
      title: 'Kompleksowe dostawy',
      subtitle:
        'Specjalizujemy się w rozwiązaniach dla B2B i aby jak najlepiej obsługiwać naszych partnerów prowadzimy sprzedaż wyłącznie do firm i instytucji.',
    },
    firstSection: {
      title: `Od ${coconStartYear} roku dostarczamy sprzęt i rozwiązania IT dla firm i partnerów B2B`,
    },
    secondSection: {
      title:
        'Realizujemy kompleksowe procesy wymiany i modernizacji sprzętu i doradzamy, jak zoptymalizować zarządzanie hardware IT w Twojej firmie.',
      titleDescription:
        'Dedykowany zespół techniczno–handlowy z aktualną wiedzą produktową i dystrybucyjną, ze wsparciem technicznym naszych inżynierów IT daje Ci gwarancję, że zakupiony sprzęt będzie zgodny z realnymi potrzebami, dostępny w wymaganym czasie oraz odpowiadający trendom rynkowym. ',
      description:
        'Obsługujemy zapytania ofertowe i realizujemy kompleksowe projekty doradztwa, dostawy i wdrożenia sprzętu oraz usług IT obejmujące:',
      itemsPerRow: 1,
      items: getListWithId([
        { text: 'analizę potrzeb i techniczną' },
        { text: 'sprzęt demo' },
        { text: 'wsparcie dedykowanego opiekuna' },
        { text: 'pomoc w przygotowaniu niezbędnej dokumentacji' },
        { text: 'dialog z producentem' },
        { text: 'dopasowane formy finansowania i płatności' },
        { text: 'dostawę i wdrożenie' },
      ]),
    },
    dialogBoxesSection: {
      firstSection: {
        title:
          'Sprawnie dostarczamy sprzęt i usługi IT naszym klientom, dzięki czemu mogą skupić się na tym co znają najlepiej – na swoim biznesie.',
        list: {
          title: 'Skontaktuj się z nam jeśli:',
          items: getListWithId([
            { text: 'odpowiadasz za zakupy lub modernizację sprzętu i usług IT' },
            { text: 'cenisz eksperckie doradztwo i terminową realizację' },
            { text: 'potrzebujesz rozwiązań dobranych do swoich potrzeb' },
          ]),
        },
      },
      secondSection: {
        title: `Specjalizujemy się w obsłudze biznesu – każdego roku dostarczamy ponad ${devices} urządzeń IT do firm i\u00A0instytucji w Polsce i Europie. `,
        description:
          'Dla wielu z nich staliśmy się partnerem IT pierwszego wyboru. Jednorazowo dostarczamy nawet kilkaset urządzeń gotowych do pracy.',
      },
    },
    prosAndConsSection,
    contactUsImageSection,
  };
};
